// filterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  objective: {
    includeKr: 2,
  },
  kr: '',
  activities: '',
  rowSelectionObjKr: '',
  orgs: '',
  orgCheckIn: {
    includeKr: 2,
  },
  approvalLevel: '',
  evaluationLevel: '',
  copyKr: '',
  resultComplete: {},
  categoryEvaluation: {},
  categoryApprove: {},
  pendingApprove: {},
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilterObjective(state, action) {
      return {
        ...state,
        objective: action.payload,
      };
    },
    setFilterKr(state, action) {
      return {
        ...state,
        kr: action.payload,
      };
    },
    setFilterActivities(state, action) {
      return {
        ...state,
        activities: action.payload,
      };
    },
    setFilterRowSelectionObjKr(state, action) {
      return {
        ...state,
        rowSelectionObjKr: action.payload,
      };
    },
    setFilterOrgCheckIn(state, action) {
      return {
        ...state,
        orgCheckIn: action.payload,
      };
    },
    setListFilterOrgCheckIn(state, action) {
      return {
        ...state,
        orgs: action.payload,
      };
    },
    setListFilterApprovalLevel(state, action) {
      return {
        ...state,
        approvalLevel: action.payload,
      };
    },
    setListFilterEvaluationLevel(state, action) {
      return {
        ...state,
        evaluationLevel: action.payload,
      };
    },
    setListFilterCopyListKr(state, action) {
      return {
        ...state,
        copyKr: action.payload,
      };
    },
    setFilterResultComplete(state, action) {
      return {
        ...state,
        resultComplete: action.payload,
      };
    },
    setFilterCategoryEvaluation(state, action) {
      return {
        ...state,
        categoryEvaluation: action.payload,
      };
    },
    setFilterCategoryApprove(state, action) {
      return {
        ...state,
        categoryApprove: action.payload,
      };
    },
    setFilterPendingApprove(state, action) {
      return {
        ...state,
        pendingApprove: action.payload,
      };
    },
    resetFilter(state) {
      return initialState;
    },
  },
});

export const {
  setFilterObjective,
  setFilterKr,
  setFilterActivities,
  setFilterRowSelectionObjKr,
  setFilterOrgCheckIn,
  setListFilterOrgCheckIn,
  setListFilterApprovalLevel,
  setListFilterEvaluationLevel,
  setListFilterCopyListKr,
  setFilterResultComplete,
  setFilterCategoryEvaluation,
  setFilterCategoryApprove,
  setFilterPendingApprove,
  resetFilter,
} = filterSlice.actions;
export default filterSlice.reducer;
